module.exports = __webpack_public_path__ + "img/driver.132134a1.png";